document.addEventListener('DOMContentLoaded', function() {
    const formFields = document.querySelectorAll('input[name="name"], input[name="email"], input[name="phone"], input[name="subject"]');
    
    formFields.forEach(function(field, index) {
        field.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                
                // Find the next field
                if (index < formFields.length - 1) {
                    formFields[index + 1].focus();
                } else {
                    // If it's the last field (subject), move to message textarea
                    const messageField = document.querySelector('textarea[name="message"]');
                    if (messageField) {
                        messageField.focus();
                    }
                }
            }
        });
    });
});

function onSendMessage(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    let formData = new FormData(form);

    if (!formData.get('email') && !formData.get('phone')) {
        showError("web.contact_error_contact");
        return;
    }

    if (!formData.get('message')) {
        showError("web.contact_error_message");
        return;
    }

    showMainSpinner();

    grecaptcha.ready(function() {
        grecaptcha.execute('6LckVWwsAAAAADNAs5GKPc__b4HEiRlG8_smc2LN', {action: 'submit'}).then(function(token) {

            const apiUrl = window.PM_CONFIG.apiUrl + '/contact';
            postContactMessage(apiUrl, token, formData, 
                function(response) {
                    hideMainSpinner();
                    if (response && response.msg) {
                        showInfo(response.msg);
                    }
                    form.reset();
                },
                function(jqXHR, textStatus, errorThrown) {
                    hideMainSpinner();
                    if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                        showError(jqXHR.responseJSON.error);
                    }
                    else {
                        showError("web.contact_error_sending_message");
                    }
                }
            );
        });
    });
}
